module.exports = __webpack_public_path__ + "static/icon-be6ad826b150eeeda92d338d98e3df6e.png";